// src/components/crm/ResourceConflictModal.js
import React from 'react';
import { X, AlertTriangle } from 'lucide-react';
import { format } from 'date-fns';

const ResourceConflictModal = ({ isOpen, onClose, conflictDetails }) => {
    if (!isOpen || !conflictDetails) return null;

    // r2-cs-conflict-6a4f2d81 — crew variant reuses this modal; absent `kind`
    // the resource path is byte-for-byte unchanged. formatDate hardened to
    // accept a Timestamp OR a JS Date.
    const { resourceName, conflictingJob, type, kind, crewName } = conflictDetails;
    const isCrew = kind === 'crew';

    const formatDate = (value) => {
        if (!value) return 'N/A';
        if (value.toDate) return format(value.toDate(), 'MMM d, h:mm a');
        if (value instanceof Date) return format(value, 'MMM d, h:mm a');
        return 'N/A';
    };

    const conflictMessage = isCrew
        ? `${crewName || 'This crew'} is already booked on another job during this time.`
        : (type === 'inUse'
            ? `${resourceName} is already assigned during this time.`
            : `${resourceName} may have a conflict (assigned within 1 hour).`);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-[70]"> {/* Ensure z-index is higher than JobFormModal */}
            <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-lg">
                <div className="flex justify-between items-center mb-4">
                    <h3 className={`text-lg font-medium flex items-center gap-2 ${isCrew ? 'text-red-600' : 'text-orange-600'}`}>
                        <AlertTriangle size={20} /> {isCrew ? 'Scheduling Conflict' : 'Potential Resource Conflict'}
                    </h3>
                    <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-200"><X size={20} /></button>
                </div>

                <div className="space-y-3 text-sm">
                    <p className="font-semibold">{conflictMessage}</p>
                    <div className="border rounded p-3 bg-gray-50">
                        <p><strong>Conflicting Job:</strong> {conflictingJob.title}</p>
                        <p><strong>Customer:</strong> {conflictingJob.customerName}</p>
                        <p><strong>Time:</strong> {formatDate(conflictingJob.startAt)} - {formatDate(conflictingJob.endAt)}</p>
                    </div>
                     <p className="text-xs text-gray-500">
                        {type === 'potentialConflict' ? 'Please verify if there is enough time to transport the equipment between jobs.' : ''}
                    </p>
                </div>

                <div className="flex justify-end pt-4 mt-4 border-t">
                    <button type="button" onClick={onClose} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">OK</button>
                </div>
            </div>
        </div>
    );
};

export default ResourceConflictModal;